/**
 * @Author: yxp
 * @Date:   2017-07-11 11:07:66
 * @Last modified by:   yxp
 * @Last modified time: 2017-07-13 16:07:42
 */
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import App from '@/pages/login';
import { ValidateDirective as validate, ProtocolFixerFilter as protocolFixer } from 'Russel';

Vue.use(validate);

Vue.config.productionTip = false;
Vue.filter('protocolFixer', protocolFixer);

const SENTRY_TEST_DSN =
  'https://9b28a9eae15c448982e20ce7958a274a@sentry.qingchengfit.cn/12';
const SENTRY_PROD_DSN =
  'https://6fd01b195c134689b1b5ba63debeacfb@sentry.qingchengfit.cn/11';

const DSN =
  location.host === 'cloud.qingchengfit.cn' ? SENTRY_PROD_DSN : SENTRY_TEST_DSN;

Raven.config(DSN)
  .addPlugin(RavenVue, Vue)
  .install();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/entries/login.js